// Shared shapes for the Communication Governance UI (Policies tab, Task 8 +
// the per-department page, Task 9). Mirrors the server-side row shapes in
// apps/server/src/lib/governance/db.ts and the zod schemas in
// apps/server/src/routes/governance.ts — keep in sync if either changes.

export type GovernanceEnforcementMode = 'notify_only' | 'post_delivery' | 'realtime_hold'
export type GovernanceRuleType = 'topic' | 'keyword' | 'barrier'
export type GovernanceRuleAction = 'notify' | 'block'
export type GovernanceSurface = 'chat' | 'voice' | 'mail'
export type GovernanceBarrierKind = 'user' | 'dept'

export interface GovernanceBarrierSide {
  kind: GovernanceBarrierKind
  id: string
}

export interface GovernancePolicy {
  id: string
  serverId: string
  departmentId: string | null
  enforcementMode: GovernanceEnforcementMode
  enabled: boolean
  createdById: string
  createdAt: string
  updatedAt: string
}

export interface GovernanceRule {
  id: string
  policyId: string
  type: GovernanceRuleType
  name: string
  aiDescription: string | null
  keywords: string[] | null
  action: GovernanceRuleAction
  surfaces: GovernanceSurface[]
  recipientIds: string[] | null
  barrierA: GovernanceBarrierSide | null
  barrierB: GovernanceBarrierSide | null
  enabled: boolean
  createdAt: string
  updatedAt: string
}

export interface GovernanceActivityEvent {
  id: string
  serverId: string
  departmentId: string | null
  ruleId: string
  ruleName: string
  ruleType: GovernanceRuleType
  surface: GovernanceSurface
  authorId: string | null
  contextRef: string
  messageRef: string | null
  snippet: string
  verdict: string
  actionTaken: string
  notifiedUserIds: string[] | null
  createdAt: string
}

export const ENFORCEMENT_MODE_OPTIONS: { value: GovernanceEnforcementMode; label: string }[] = [
  { value: 'post_delivery', label: 'Post-delivery — message sends, then hides on violation (default)' },
  { value: 'realtime_hold', label: 'Real-time hold — message waits for AI verdict (~1-2s)' },
  { value: 'notify_only', label: 'Notify only — never blocks, alerts only' },
]

export const SURFACE_OPTIONS: { value: GovernanceSurface; label: string }[] = [
  { value: 'chat', label: 'Chat' },
  { value: 'voice', label: 'Voice' },
  { value: 'mail', label: 'Mail' },
]
